import React, { FC } from 'react'

import { Skeleton } from '@interco/inter-ui/components/Skeleton'

import { QuestionsDetailsSkeletonContainer } from './styles'

export const QuestionsDetailsSkeleton: FC = () => (
  <QuestionsDetailsSkeletonContainer>
    <Skeleton width="100%" height="12px" />
    <Skeleton width="90%" height="12px" />
    <Skeleton width="70%" height="12px" />
    <Skeleton width="100%" height="12px" />
    <Skeleton width="90%" height="12px" />
    <Skeleton width="65%" height="12px" />
    <Skeleton width="100%" height="12px" />
    <Skeleton width="90%" height="12px" />
    <Skeleton width="70%" height="12px" />
    <Skeleton width="100%" height="12px" />
    <Skeleton width="90%" height="12px" />
    <Skeleton width="65%" height="12px" />
    <Skeleton width="100%" height="12px" />
    <Skeleton width="85%" height="12px" />
    <Skeleton width="50%" height="12px" />
  </QuestionsDetailsSkeletonContainer>
)
